import React from 'react';
import cn from 'classnames';
import { string, node } from 'prop-types';

const propTypes = {
  children: node,
  className: string,
};

const CustomTableCell = ({
  children,
  className,
  sorting,
  sortBy,
  sortOrder,
  sortName,
  handleSort,
  defaultSortOrder,
  ...rest
}) => {
  let classes = cn('table-cell', className);
  const onSort = () => {
    let by;
    if(sortName === sortBy) {
      if(sortOrder === 'asc') {
        by = 'desc';
      } else {
        by = 'asc';
      }
    } else {
      if(defaultSortOrder) {
        by = defaultSortOrder;
      } else {
        by = 'asc';
      }
    }
    handleSort(sortName, by);
  };
  if(sorting) {
    classes = cn(
      'table-cell',
      {
        [className]: className,
        sorting,
        sortByCurrent: typeof sortName === 'string' && sortName === sortBy,
        asc: sortOrder === 'asc',
        desc: sortOrder === 'desc',
      },
    );
  }
  return (
    <div
      className={classes}
      role="cell"
      onClick={() => sorting ? onSort() : false}
      {...rest}
    >
      {children}
    </div>
  );
};

CustomTableCell.propTypes = propTypes;

export default CustomTableCell;
